import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import {
  Button,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  TextField,
  InputLabel,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Vector from "../../../../../assets/images/Vector.svg";
import insta from "../../../../../assets/images/insta.svg";
import linkedin from "../../../../../assets/images/linkedin.svg";
import fb from "../../../../../assets/images/fb.svg";
import DragAndDropInput from "../../../../../components/DragAndDropInput";
import CustomInput from "../../../../../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { AddNewEmployeeValidation } from "../../../../../helper/Validation";
import styles from "./style";
import { formatFormDate } from "../../../../../utils/DateFormat";
import { LoadingButton } from "@mui/lab";
import DocumentUpload from "../../../../../components/DocumentUpload";
import Modal from "../../../../../components/Modal";
import countryList from "react-select-country-list";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { number } from "currency-codes";
import { nationalities, updateProfileData } from "./data";
import { SPECIAL_PROJECTS } from "../../../../../constants/data";
import { Download } from "@mui/icons-material";
// --------------------------------------------------------------------------------------------------------------------
// Edit a employee information
// --------------------------------------------------------------------------------------------------------------------

const ViewEmployeePage = ({
  registerEmployee,
  userData,
  handleUrl,
  handleNavigate,
  loading,
  handleMultipleUrl,
  CountryCode,
  data,
  departmentData,
  setDocument,
  document,
  payslip,
  disable,
  getOneEmployee,
  oneEmloyeeData,
  projectList,
  handleExportPdf,
  handleSendEmail,
  sendEmailLoading

}) => {
  const isReadOnly = disable ?? true;
  const [mobile, setMobile] = useState(
    userData?.personalInfo?.mobile.toString()
  );
  const [emergency, setEmergency] = useState(
    userData?.otherInformation?.emergencyContact
      ? userData.otherInformation.emergencyContact.toString()
      : ""
  );

  const [workplace, setWorkplace] = useState(
    userData?.otherInformation?.workplace
      ? userData.otherInformation.workplace.toString()
      : ""
  );

  const [cCode, setCCode] = useState("");
  const [emergencyCode, setEmergencyCode] = useState("");
  const [workplaceCode, setWorkplaceCode] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("");
  const handleChanges = (name, value) => {
    setSelectedNationality(value);
  };
  useEffect(() => {
    setSendEmail(userData?.personalInfo?.email || userData?.email || "");
  }, [userData]);
  const mobileNumberRef = useRef(null);

  const updateProfile = updateProfileData(userData);

  const [selectedProjects, setSelectedProjects] = useState(
    updateProfile?.projects?.value?.map(p => p.name) || []
  );
  const [sendEmailOpen, setSendEmailOpen] = useState(false);
  const [sendEmail, setSendEmail] = useState(
    userData?.personalInfo?.email || userData?.email || ""
  );

  const onRegister = (formData) => {
    const data = {
      ...formData,
      projects: {
        value: selectedProjects?.map(projectName => {
          const project = projectList.find(p => p.name === projectName);
          const mappedStatus =
            project?.status === "Running" || project?.status === "Active"
              ? "active"
              : project?.status === "Completed"
                ? "completed"
                : project?.status === "Cancelled"
                  ? "cancelled"
                  : "active";
          return {
            name: projectName,
            status: mappedStatus
          };
        })
      }
    };

    registerEmployee(
      data,
      userData,
      mobile,
      cCode,
      emergency,
      emergencyCode,
      workplace,
      workplaceCode,
      selectedNationality
    );
    getOneEmployee(userData?._id);
  };

  const [docs1, setDocs1] = useState(updateProfile?.doc?.value);
  const handleAddDoc = () => {
    if (isReadOnly) return;
    setDocs1([...docs1, { name: "", url: "" }]);
    setDocument([...document, { name: "", url: "" }]);
  };

  const handleDeleteDoc = (index) => {
    if (isReadOnly) return;
    const updatedDoc = [...docs1];
    const updatedDocument = [...document];
    updatedDoc.splice(index, 1);
    setDocs1(updatedDoc);
    updatedDocument.splice(index, 1);
    setDocument(updatedDocument);
  };

  const handleDocChange = (value, index, key) => {
    if (isReadOnly) return;
    setDocument((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = { ...updatedItems[index], [key]: value };
      return updatedItems;
    });
  };

  const openSendEmailModal = () => {
    setSendEmail(userData?.personalInfo?.email || userData?.email || "");
    setSendEmailOpen(true);
  };

  const handleSendEmailSubmit = async () => {
    if (handleSendEmail) {
      await handleSendEmail(sendEmail?.trim());
    }
    setSendEmailOpen(false);
  };

  const options = countryList().getData();

  const handleOnChanges = (value, country) => {
    if (isReadOnly) return;
    setMobile(value);
    setCCode(country?.dialCode);
  };

  const handleEmergencyChanges = (value, country) => {
    if (isReadOnly) return;
    setEmergency(value);
    setEmergencyCode(country?.dialCode);
  };

  const handleWorkplaceChanges = (value, country) => {
    if (isReadOnly) return;
    setWorkplace(value);
    setWorkplaceCode(country?.dialCode);
  };

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    updateProfile,
    AddNewEmployeeValidation,
    onRegister
  );
  const {
    firstName,
    lastName,
    gender,
    // mobile,
    nickName,
    password,
    confirmPassword,
    jobPosition,
    department,
    address1,
    address2,
    city,
    zipCode,
    country,
    email,
    dob,
    education,
    salary,
    // nationality,
    religion,
    marital,
    passportNum,
    hourlyRate,
    bankName,
    accountNum,
    ifscCode,
    accountHolder,
    personalTaxCode,
    joiningDate,
    experience,
    isActive,
    empNumber,
    idNumber,
    taxRefNo,
    medicalAidNo,
    taskNoti,
    urlSkype,
    urlLinkedin,
    urlInsta,
    restraintTrade,
    isOverTime,
    isTracked,
    empType,
    start,
    end,
    rate,
    payfreq,
    paymentType,
    rateRembTravel,
    accountType,
    urlFb,
    isExtraTime,
    isDoubleOverTime,
    extraTimeRate,
    doubleOverTimeRate,
  } = state;
  return (
    <>
      <Modal
        open={sendEmailOpen}
        setOpen={setSendEmailOpen}
        title="Attendance Details"
        handleCheck={handleSendEmailSubmit}
        btnText="Send"
        loading={sendEmailLoading}
        disabled={!sendEmail?.trim()}
      >
        <Box sx={{ minWidth: { xs: "260px", sm: "420px" } }}>
          <InputLabel>Employee Email</InputLabel>
          <TextField
            fullWidth
            placeholder="Enter email"
            value={sendEmail}
            onChange={(e) => setSendEmail(e.target.value)}
            sx={{ mt: 1 }}
          />
        </Box>
      </Modal>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "20px",
          mr: "30px",
          mt: "20px",
          float: "right",
        }}
      >
        <Button
          type="button"
          onClick={openSendEmailModal}
          sx={{ ...styles.exportBtn, mr: 0, mt: 0 }}
        >
          Send Email
        </Button>
        <Button
          type="button"
          onClick={handleExportPdf}
          sx={{ ...styles.exportBtn, mr: 0, mt: 0 }}
        >
          <Download />
          Export Pdf
        </Button>
      </Box>
      <Box sx={{ pl: 2, ...(isReadOnly ? styles.readOnlyWrapper : {}) }}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <Grid container display="flex" flexDirection="row">
            <Grid item lg={6} sm={12}>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Personal Information</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        mb: "2%",
                        height: "5em",
                      }}
                    >
                      <DragAndDropInput
                        profileImg={updateProfile?.profileImg?.value}
                        handleUrl={handleUrl}
                        isFrom="edit"
                        disabled={isReadOnly}
                      />
                      <Typography sx={{ ...styles.changeText, color: isReadOnly ? "#9ca3af" : styles.changeText.color }}>
                        {"Change Profile Photo"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}> First Name<span style={{ color: "red" }}>*</span> </Typography>
                      <CustomInput
                        sx={styles.inputsize}
                        defaultValue={updateProfile?.firstName?.value}
                        name="firstName"
                        value={firstName?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={firstName?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Surname<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="lastName"
                        defaultValue={updateProfile?.lastName?.value}
                        value={lastName?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={lastName?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Nick Name</Typography>
                      <CustomInput
                        name="nickName"
                        defaultValue={updateProfile?.nickName?.value}
                        value={nickName?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={nickName?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {/* <CustomInput
                      name="dob"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      defaultValue={formatFormDate(updateProfile?.dob?.value)}
                      value={dob?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={dob.error}
                    />
 */}

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Typography sx={styles.textsize}>
                          Date Of Birth<span style={{ color: "red" }}>*</span>
                        </Typography>
                        <DatePicker
                          defaultValue={updateProfile?.dob?.value}
                          name="dob"
                          value={dob.value ? dayjs(dob.value) : null}
                          maxDate={dayjs().subtract(16, "year")}
                          onChange={(newValue) => {
                            handleChange(
                              "dob",
                              newValue ? newValue.format("YYYY-MM-DD") : null
                            );
                          }}
                          error={dob.error}
                          sx={styles.dateInput}
                          disabled
                          slotProps={{
                            field: {
                              readOnly: true,
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.9em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                          },
                        }}
                      >
                        <Typography sx={styles.textsize}>Nationality<span style={{ color: "red" }}>*</span></Typography>

                        <Select
                          value={selectedNationality || updateProfile?.nationality?.value}
                          onChange={(e) => handleChanges("nationality", e.target.value)}
                          name="nationality"
                          onFocus={handleFocus}
                          defaultValue={updateProfile?.nationality?.value}
                          sx={styles.dropDownMenu}
                          placeholder={updateProfile?.nationality?.value}
                          disabled
                        >

                          {nationalities?.map((item, index) => (
                            <MenuItem key={index} sx={styles.dropDownMenu} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Id/Pas Number<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        fullWidth
                        name="passportNum"
                        defaultValue={updateProfile?.passportNum.value}
                        value={passportNum?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={passportNum.error}
                        readOnly={true}
                      />
                    </Grid>


                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.9em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                          },
                        }}
                      >
                        <Typography sx={styles.textsize}>Gender<span style={{ color: "red" }}>*</span></Typography>
                        {/* <InputLabel>Gender</InputLabel> */}
                        <Select
                          defaultValue={updateProfile?.gender?.value}
                          value={
                            gender.value
                              ? gender?.value
                              : updateProfile?.gender?.value
                          }
                          onChange={(e) => handleChange("gender", e.target.value)}
                          name="gender"
                          // label="Gender"
                          onFocus={handleFocus}
                          error={gender?.error}
                          sx={styles.dropDownMenu}
                          disabled
                        >
                          <MenuItem sx={styles.dropDownMenu} value="male">
                            Male
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="female">
                            Female
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="other">
                            Other
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={styles.mobileGrid}>
                        <Typography sx={styles.textsize}>Mobile<span style={{ color: "red" }}>*</span></Typography>

                        <PhoneInput
                          country={"za"}
                          enableSearch={true}
                          defaultValue={
                            cCode || updateProfile?.mobile?.value?.toString()
                          }
                          value={mobile}
                          name="mobile"
                          onChange={(value, country) =>
                            handleOnChanges(value, country)
                          }
                          onFocus={handleFocus}
                          ref={mobileNumberRef} // Assign ref to access DOM element
                          error={mobile.error}
                          sx={styles.mobile}
                          inputStyle={
                            isReadOnly
                              ? {
                                  backgroundColor: "#f5f5f5",
                                  color: "#6b7280",
                                  borderRadius: "10px",
                                  border: "1px solid #d1d5db",
                                  width: "100%",
                                }
                              : undefined
                          }
                          buttonStyle={
                            isReadOnly
                              ? {
                                  backgroundColor: "#f5f5f5",
                                  border: "1px solid #d1d5db",
                                }
                              : undefined
                          }
                          disabled={isReadOnly}
                          inputProps={{
                            disabled: isReadOnly,
                            style: {
                              height: "1em",
                              borderRadius: "10px",
                              backgroundColor: "#f5f5f5",
                              color: "#6b7280",
                              cursor: "not-allowed",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Password <span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="password"
                        type="password"
                        value={password.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={password.error}
                        readOnly={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Confirm Password <span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="confirmPassword"
                        type="password"
                        value={confirmPassword.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={confirmPassword.error}
                        matchPassword={password.value}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Job Position<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="jobPosition"
                        value={jobPosition?.value}
                        defaultValue={updateProfile?.jobPosition?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={jobPosition?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.9em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                          },
                        }}
                      >
                        <Typography sx={styles.textsize}>Department<span style={{ color: "red" }}>*</span></Typography>
                        {/* <InputLabel>Department</InputLabel> */}

                        <Select
                          defaultValue={updateProfile?.department?.value}
                          value={department.value}
                          onChange={(e) =>
                            handleChange("department", e.target.value)
                          }
                          name="department"
                          onFocus={handleFocus}
                          error={department?.error}
                          sx={styles.dropDownMenu}
                          disabled
                        >
                          {departmentData?.map((item, index) => (
                            <MenuItem
                              key={index}
                              sx={styles.dropDownMenu}
                              value={item?.name}
                            >
                              {item?.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>
                        Physical Address<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <CustomInput
                        name="address1"
                        defaultValue={updateProfile?.address1?.value}
                        value={address1?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        multiline
                        error={address1?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Postal Address<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="address2"
                        defaultValue={updateProfile?.address2?.value}
                        value={address2?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        multiline
                        error={address2?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>City<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="city"
                        defaultValue={updateProfile?.city?.value}
                        value={city?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={city?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Zip Code<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="zipCode"
                        defaultValue={updateProfile?.zipCode?.value}
                        value={zipCode?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={zipCode?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.8em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                          },
                        }}
                      >
                        <Typography sx={styles.textsize} shrink={true}>
                          Country<span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Select
                          defaultValue={updateProfile?.country?.value}
                          value={country?.value}
                          onChange={(event) => {
                            handleChange("country", event.target.value),
                              CountryCode(event.target.value);
                          }}
                          name="country"
                          sx={styles.dropDownMenu}
                          onFocus={handleFocus}
                          error={country.error}
                          disabled
                        >
                          {options.map((country, index) => (
                            <MenuItem
                              key={index}
                              sx={styles.dropDownMenu}
                              value={country.label}
                            >
                              {country.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Email<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="email"
                        defaultValue={updateProfile?.email?.value}
                        value={email?.value}
                        // editable={true}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={email?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Education<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="education"
                        defaultValue={updateProfile?.education.value}
                        value={education?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={education.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Employee Id<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="empNumber"
                        defaultValue={updateProfile?.empNumber.value}
                        value={empNumber?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={empNumber.error}
                        readOnly={true}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormControlLabel
                        sx={styles.formControlLabel}
                        control={
                          <Checkbox
                            defaultChecked={updateProfile?.isActive?.value}
                            disabled
                          />

                        }
                        checked={isActive?.value}
                        onChange={(e) =>
                          handleChange("isActive", e.target.checked)
                        }
                        label="Is Active"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Additional Options</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1} sx={{ display: "block" }}>
                    {/* <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={
                            updateProfile?.profileVisibility.value
                          }
                          checked={profileVisibility?.value}
                        />
                      }
                      onChange={(e) =>
                        handleChange("profileVisibility", e.target.checked)
                      }
                      label="Profile Visibility For Everyone"
                    />
                  </Grid> */}
                    {/* <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={updateProfile?.isPreAttendance?.value}
                        />
                      }
                      checked={
                        isPreAttendance?.value
                        // ? isPreAttendance?.value
                        // : updateProfile?.isPreAttendance.value
                      }
                      onChange={(e) =>
                        handleChange("isPreAttendance", e.target.checked)
                      }
                      label="Access For Editing Previous Attendance"
                    />
                  </Grid> */}
                    <Grid>
                      <FormControlLabel
                        sx={styles.formControlLabel}
                        control={
                          <Checkbox
                            defaultChecked={updateProfile?.taskNoti.value}
                            disabled
                          />
                        }
                        checked={
                          taskNoti?.value
                          // ? taskNoti?.value
                          // : updateProfile?.taskNoti.value
                        }
                        onChange={(e) =>
                          handleChange("taskNoti", e.target.checked)
                        }
                        label="New Task Notifications"
                      />
                    </Grid>
                    <Grid>
                      <FormControlLabel
                        sx={styles.formControlLabel}
                        control={
                          <Checkbox
                            defaultChecked={updateProfile?.isTracked?.value}
                            disabled
                          />
                        }
                        checked={
                          isTracked?.value
                          // ? taskNoti?.value
                          // : updateProfile?.taskNoti.value
                        }
                        onChange={(e) =>
                          handleChange("isTracked", e.target.checked)
                        }
                        label="Is Tracked"
                      />
                    </Grid>
                    <Grid>
                      <FormControlLabel
                        sx={styles.formControlLabel}
                        control={
                          <Checkbox
                            defaultChecked={updateProfile?.isOverTime?.value}
                            disabled
                          />
                        }
                        checked={
                          isOverTime?.value
                          // ? taskNoti?.value
                          // : updateProfile?.taskNoti.value
                        }
                        onChange={(e) =>
                          handleChange("isOverTime", e.target.checked)
                        }
                        label="Allow Overtime"
                      />
                    </Grid>

                    {isOverTime?.value && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={styles.textsize}>eg Rate x 1.5</Typography>
                        <CustomInput
                          fullWidth
                          name="rate"
                          placeholder={"0.0"}
                          value={rate?.value}
                          defaultValue={updateProfile?.rate?.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          error=""
                          readOnly={true}
                        />
                      </Grid>
                    )}
                    <Grid>
                      <FormControlLabel
                        sx={styles.formControlLabel}
                        control={
                          <Checkbox
                            defaultChecked={
                              updateProfile?.isDoubleOverTime?.value
                            }
                            disabled
                          />
                        }
                        checked={
                          isDoubleOverTime?.value
                          // ? taskNoti?.value
                          // : updateProfile?.taskNoti.value
                        }
                        onChange={(e) =>
                          handleChange("isDoubleOverTime", e.target.checked)
                        }
                        label="Allow DoubleOverTime"
                      />
                    </Grid>

                    {isDoubleOverTime?.value && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={styles.textsize}>eg Rate x 2</Typography>

                        <CustomInput
                          fullWidth
                          name="doubleOverTimeRate"
                          placeholder={"0.0"}
                          value={doubleOverTimeRate?.value}
                          defaultValue={updateProfile?.doubleOverTimeRate.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          error=""
                          readOnly={true}
                        />
                      </Grid>
                    )}

                    <Grid>
                      <FormControlLabel
                        sx={styles.formControlLabel}
                        control={
                          <Checkbox
                            defaultChecked={updateProfile?.isExtraTime?.value}
                            disabled
                          />
                        }
                        checked={
                          isExtraTime?.value
                          // ? taskNoti?.value
                          // : updateProfile?.taskNoti.value
                        }
                        onChange={(e) =>
                          handleChange("isExtraTime", e.target.checked)
                        }
                        label="Allow ExtraTime"
                      />
                    </Grid>

                    {isExtraTime?.value && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={styles.textsize}>eg Rate x 1.3</Typography>

                        <CustomInput
                          fullWidth
                          name="extraTimeRate"
                          placeholder={"0.0"}
                          value={extraTimeRate?.value}
                          defaultValue={updateProfile?.extraTimeRate.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          error=""
                          readOnly={true}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Other Information</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Religion</Typography>
                      <CustomInput
                        fullWidth
                        name="religion"
                        defaultValue={updateProfile?.religion?.value}
                        value={religion?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={religion.error}
                        readOnly={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.9em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                          },
                        }}
                      >
                        <Typography sx={styles.textsize}>Marital</Typography>
                        {/* <InputLabel>Marital</InputLabel> */}
                        <Select
                          defaultValue={updateProfile?.marital?.value}
                          value={
                            marital?.value
                              ? marital?.value
                              : updateProfile?.marital.value
                          }
                          onChange={(e) =>
                            handleChange("marital", e.target.value)
                          }
                          name="Marital"
                          placeholder="Marital"
                          handleFocus={handleFocus}
                          error={marital?.error}
                          sx={styles.dropDownMenu}
                          disabled
                        >
                          <MenuItem sx={styles.dropDownMenu} value="Yes">
                            Yes
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="No">
                            No
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={styles.mobileGrid}>
                        <Typography sx={styles.textsize}>
                          Emergency Contact
                        </Typography>

                        <PhoneInput
                          country={"za"}
                          enableSearch={true}
                          defaultValue={
                            emergencyCode ||
                            updateProfile?.emergencyContact?.value?.toString() ||
                            ""
                          }
                          value={emergency}
                          name="mobile"
                          onChange={(value, country) =>
                            handleEmergencyChanges(value, country)
                          }
                          onFocus={handleFocus}
                          ref={mobileNumberRef}
                          error={mobile.error}
                          sx={styles.mobile}
                          inputStyle={
                            isReadOnly
                              ? {
                                  backgroundColor: "#f5f5f5",
                                  color: "#6b7280",
                                  borderRadius: "10px",
                                  border: "1px solid #d1d5db",
                                  width: "100%",
                                }
                              : undefined
                          }
                          buttonStyle={
                            isReadOnly
                              ? {
                                  backgroundColor: "#f5f5f5",
                                  border: "1px solid #d1d5db",
                                }
                              : undefined
                          }
                          disabled={isReadOnly}
                          inputProps={{
                            disabled: isReadOnly,
                            style: {
                              height: "1em",
                              borderRadius: "10px",
                              backgroundColor: "#f5f5f5",
                              color: "#6b7280",
                              cursor: "not-allowed",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={styles.mobileGrid}>
                        <Typography sx={styles.textsize}>Workplace</Typography>
                        <PhoneInput
                          country={"za"}
                          enableSearch={true}
                          defaultValue={
                            workplaceCode ||
                            updateProfile?.workplace?.value?.toString()
                          }
                          value={workplace}
                          name="mobile"
                          onChange={(value, country) =>
                            handleWorkplaceChanges(value, country)
                          }
                          onFocus={handleFocus}
                          ref={mobileNumberRef}
                          error={mobile.error}
                          sx={styles.mobile}
                          inputStyle={
                            isReadOnly
                              ? {
                                  backgroundColor: "#f5f5f5",
                                  color: "#6b7280",
                                  borderRadius: "10px",
                                  border: "1px solid #d1d5db",
                                  width: "100%",
                                }
                              : undefined
                          }
                          buttonStyle={
                            isReadOnly
                              ? {
                                  backgroundColor: "#f5f5f5",
                                  border: "1px solid #d1d5db",
                                }
                              : undefined
                          }
                          disabled={isReadOnly}
                          inputProps={{
                            disabled: isReadOnly,
                            style: {
                              height: "1em",
                              borderRadius: "10px",
                              backgroundColor: "#f5f5f5",
                              color: "#6b7280",
                              cursor: "not-allowed",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6} sm={12}>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Salary Information</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    {/* <Grid item xs={12} sm={6}>
                      <CustomInput
                        fullWidth
                        label="Payroll NName"
                        name="payrollName"
                        defaultValue={updateProfile?.payrollName.value}
                        onChange={handleChange}
                        value={payrollName?.value}
                        onFocus={handleFocus}
                        error={payrollName.error} />
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Salary<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        name="salary"
                        defaultValue={updateProfile?.salary.value}
                        value={salary.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={salary.error}
                        readOnly={true}
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <CustomInput
                        label="Increment"
                        name="increment"
                        defaultValue={updateProfile?.increment.value}
                        value={increment?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={increment.error} />
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.9em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                          },
                        }}
                      >
                        <Typography sx={styles.textsize}> Rate<span style={{ color: "red" }}>*</span></Typography>
                        {/* <InputLabel>Rate</InputLabel> */}
                        <Select
                          defaultValue={updateProfile?.hourlyRate?.value}
                          value={
                            hourlyRate?.value
                              ? hourlyRate?.value
                              : updateProfile?.hourlyRate.value
                          }
                          onChange={(e) =>
                            handleChange("hourlyRate", e.target.value)
                          }
                          name="hourlyRate"
                          // label="Hourly Rate"
                          handleFocus={handleFocus}
                          error={hourlyRate?.error}
                          sx={styles.dropDownMenu}
                          disabled
                        >
                          <MenuItem sx={styles.dropDownMenu} value="Hourly">
                            Hourly
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Salary">
                            Salary
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>
                        Restraint Of Trade
                      </Typography>
                      <CustomInput
                        fullWidth
                        name="restraintTrade"
                        // type="Number"
                        defaultValue={updateProfile?.restraintTrade.value}
                        value={restraintTrade?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={restraintTrade.error}
                        readOnly={true}
                      />
                    </Grid>

                    {/* <Grid item xs={12} sm={6}>
                      <CustomInput
                        fullWidth
                        label="Annual Bonuses"
                        name="annualBonus"
                        // type="Number"
                        defaultValue={updateProfile?.annualBonus.value}
                        value={annualBonus?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={annualBonus.error}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={styles.formControl}>
                        <Typography sx={styles.textsize} shrink={true}>
                          Pay Frequency<span style={{ color: "red" }}>*</span>
                        </Typography>
                        {/* <InputLabel shrink={true}>Pay Frequency</InputLabel> */}
                        <Select
                          defaultValue={updateProfile?.payfreq?.value}
                          value={
                            payfreq?.value
                              ? payfreq?.value
                              : updateProfile?.payfreq.value
                          }
                          // label="Pay Frequency"
                          onChange={(e) =>
                            handleChange("payfreq", e.target.value)
                          }
                          name="payfreq"
                          sx={styles.dropDownMenu}
                          displayEmpty
                          disabled
                        >
                          <MenuItem disabled value="">
                            Select
                          </MenuItem>

                          <MenuItem sx={styles.dropDownMenu} value="Monthly">
                            Monthly
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Weekly">
                            Weekly
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Fortnight">
                            Fortnight
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Custom">
                            Custom
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={styles.formControl}>
                        <Typography sx={styles.textsize} shrink={true}>
                          Payment Type<span style={{ color: "red" }}>*</span>
                        </Typography>
                        {/* <InputLabel shrink={true}>Payment Type</InputLabel> */}
                        <Select
                          defaultValue={updateProfile?.paymentType?.value}
                          value={
                            paymentType?.value
                              ? paymentType?.value
                              : updateProfile?.paymentType.value
                          }
                          // label="Payment Type"
                          onChange={(e) =>
                            handleChange("paymentType", e.target.value)
                          }
                          name="paymentType"
                          sx={styles.dropDownMenu}
                          displayEmpty
                          disabled
                        >
                          <MenuItem disabled value="">
                            Select
                          </MenuItem>

                          <MenuItem sx={styles.dropDownMenu} value="Cash">
                            Cash
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Cheque">
                            Cheque
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Transfer">
                            Transfer
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Typography sx={styles.textsize}>
                        Rate Per Kilometre On Reimbursive Travel
                      </Typography>
                      <CustomInput
                        fullWidth
                        name="rateRembTravel"
                        // type="Number"
                        defaultValue={updateProfile?.rateRembTravel.value}
                        value={rateRembTravel?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={rateRembTravel.error}
                        readOnly={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Bank Information</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Bank Name<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        fullWidth
                        name="bankName"
                        defaultValue={updateProfile?.bankName.value}
                        value={bankName?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={bankName.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Account<span style={{ color: "red" }}>*</span></Typography>

                      <CustomInput
                        fullWidth
                        name="accountNum"
                        defaultValue={updateProfile?.accountNum.value}
                        value={accountNum?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={accountNum.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>
                        {country === "India"
                          ? "Name IFSC"
                          : data?.bankCode || "Branch Code"}
                      </Typography>
                      <CustomInput
                        fullWidth
                        // label={data?.bankCode || "Branch Code"}
                        name="ifscCode"
                        value={ifscCode?.value}
                        defaultValue={updateProfile?.ifscCode.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={ifscCode.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Account Holder<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        fullWidth
                        name="accountHolder"
                        defaultValue={updateProfile?.accountHolder.value}
                        onChange={handleChange}
                        value={accountHolder?.value}
                        onFocus={handleFocus}
                        error={accountHolder.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Account Type<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        fullWidth
                        // label="Account Type"
                        name="accountType"
                        defaultValue={updateProfile?.accountType.value}
                        onChange={handleChange}
                        value={accountType?.value}
                        onFocus={handleFocus}
                        error={accountType.error}
                        readOnly={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>
                        {country === "India"
                          ? "Name GST "
                          : data?.taxCode || "Personal Income Tax"}
                      </Typography>

                      <CustomInput
                        fullWidth
                        // label={data?.taxCode || "Personal Tax Number"}
                        type={number}
                        name="personalTaxCode"
                        defaultValue={updateProfile?.personalTaxCode.value}
                        value={personalTaxCode?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={personalTaxCode.error}
                        readOnly={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Experience</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Joining Date<span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        fullWidth
                        // label="Joining Date"
                        name="joiningDate"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        defaultValue={formatFormDate(
                          updateProfile?.joiningDate.value
                        )}
                        value={joiningDate.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={joiningDate.error}
                        readOnly={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>
                        Total Years Of Experience<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <CustomInput
                        fullWidth
                        // label="Total Years Of Experience"
                        name="experience"
                        defaultValue={updateProfile?.experience.value}
                        value={experience?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={experience.error}
                        readOnly={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Employee Type</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1} mr={4}>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.8em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                            mb: 1,
                            ml: -0.7,
                          },
                        }}
                      >
                        <Typography sx={styles.textsize} shrink={true}>
                          Choose Employee Type<span style={{ color: "red" }}>*</span>
                        </Typography>
                        {/* <InputLabel shrink={true}>Choose Employee Type</InputLabel> */}
                        <Select
                          defaultValue={updateProfile?.empType?.value}
                          value={
                            empType.value
                              ? empType?.value
                              : updateProfile?.empType?.value
                          }
                          onChange={(e) =>
                            handleChange("empType", e.target.value)
                          }
                          name="empType"
                          sx={styles.dropDownMenu}
                          onFocus={handleFocus}
                          error={empType.error}
                          displayEmpty
                          disabled
                        >
                          <MenuItem disabled value="">
                            Select
                          </MenuItem>

                          <MenuItem sx={styles.dropDownMenu} value="director">
                            Director
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="employee">
                            Employee
                          </MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="contractor">
                            Contractor
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} ms={10}>
                      <FormControl
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "2.8em",
                            marginTop: "0.5em",
                            borderRadius: "10px",
                            mb: 1,
                          },
                        }}
                      >
                        <Typography shrink={true} sx={styles.textsize}>Project</Typography>
                        <Select
                          defaultValue={updateProfile?.projects?.value}
                          fullWidth
                          multiple
                          name="projects"
                          value={selectedProjects}
                          onChange={(e) => {
                            setSelectedProjects(e.target.value);
                            const selectedProjectsWithStatus = e.target.value.map(projectName => {
                              const project = projectList.find(p => p.name === projectName);
                              let mappedStatus = "active"; // Default status

                              if (project?.status) {
                                switch (project.status.toLowerCase()) {
                                  case "Running":
                                  case "active":
                                    mappedStatus = "active";
                                    break;
                                  case "Completed":
                                    mappedStatus = "completed";
                                    break;
                                  case "Cancelled":
                                    mappedStatus = "cancelled";
                                    break;
                                }
                              }

                              return {
                                name: projectName,
                                status: mappedStatus
                              };
                            });
                            handleChange("projects", {
                              value: selectedProjectsWithStatus
                            });
                          }}
                          disabled
                          sx={styles.dropDownMenu}
                          displayEmpty
                          renderValue={(selected) => {
                            if (!selected || selected.length === 0) {
                              return <span style={{ color: "#aaa" }}>Select Projects</span>;
                            }
                            return selected.join(", "); // show names
                          }}
                        >
                          <MenuItem value={""} style={styles.dropdownMenu} disabled>Select</MenuItem>
                          {projectList?.map((item, index) => (
                            <MenuItem value={item?.name} key={index} style={styles.dropdownMenu}>
                              {item?.name}
                            </MenuItem>
                          ))}
                          <MenuItem value={SPECIAL_PROJECTS.DEDUCTION.value} style={styles.dropdownMenu}>
                            {SPECIAL_PROJECTS.DEDUCTION.name}
                          </MenuItem>
                          <MenuItem value={SPECIAL_PROJECTS.HOLIDAY.value} style={styles.dropdownMenu}>
                            {SPECIAL_PROJECTS.HOLIDAY.name}
                          </MenuItem>
                          <MenuItem value={SPECIAL_PROJECTS.OVERTIME.value} style={styles.dropdownMenu}>
                            {SPECIAL_PROJECTS.OVERTIME.name}
                          </MenuItem>
                          <MenuItem value={SPECIAL_PROJECTS.EXTRATIME.value} style={styles.dropdownMenu}>
                            {SPECIAL_PROJECTS.EXTRATIME.name}
                          </MenuItem>
                          <MenuItem value={SPECIAL_PROJECTS.DOUBLE_OVERTIME.value} style={styles.dropdownMenu}>
                            {SPECIAL_PROJECTS.DOUBLE_OVERTIME.name}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    {empType.value === "contractor" && (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                          <Typography sx={styles.textsize}>Start</Typography>
                          <CustomInput
                            fullWidth
                            name="start"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={formatFormDate(
                              updateProfile?.start.value
                            )}
                            value={start?.value}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            error={start.error}
                            readOnly={true}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Typography sx={styles.textsize}>End</Typography>
                          <CustomInput
                            fullWidth
                            name="end"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={formatFormDate(
                              updateProfile?.end.value
                            )}
                            value={end?.value}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            error={end?.error}
                            readOnly={true}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Tax Information</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>ID Number <span style={{ color: "red" }}>*</span></Typography>
                      <CustomInput
                        fullWidth
                        name="idNumber"
                        placeholder={"ID Number"}
                        defaultValue={updateProfile?.idNumber?.value}
                        value={idNumber?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={idNumber?.error}
                        readOnly={true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Tax Ref. No</Typography>
                      <CustomInput
                        fullWidth
                        name="taxRefNo"
                        placeholder={"Tax Ref. No"}
                        defaultValue={updateProfile?.taxRefNo?.value}
                        value={taxRefNo?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={taxRefNo?.error}
                        readOnly={true}
                      />
                    </Grid>
                    {/* UIF Number field removed as per requirements */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>Medical Aid No</Typography>
                      <CustomInput
                        fullWidth
                        name="medicalAidNo"
                        placeholder={"Medical Aid No"}
                        defaultValue={updateProfile?.medicalAidNo?.value}
                        value={medicalAidNo?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={medicalAidNo?.error}
                        readOnly={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.subTitle}>Documents</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={2} sx={{ display: "flex-wrap" }}>
                    {docs1?.map((item, index) => (
                      <>
                        <Grid item xs={4.5} key={index}>
                          <DocumentUpload
                            name="url"
                            handleUrl={(file) => {
                              if (isReadOnly) return;
                              setDocs1((prevDocs) => [...prevDocs, file]);
                            }}
                            docs={docs1}
                            setDocs={setDocs1}
                            value={docs1}
                            fileName={document[index]?.name || item?.name}
                            image={item?.url}
                            handleimage={(val) => {
                              if (isReadOnly) return;
                              handleMultipleUrl(val, index);
                            }}
                            onChange={(e) =>
                              handleDocChange(e.target.value, index, "url")
                            }
                            disabled={isReadOnly}
                          />
                          <Box>
                            <TextField
                              sx={{ py: "0px" }}
                              name="name"
                              placeholder="File Name"
                              value={document[index]?.name || item?.name}
                              onChange={(e) => {
                                handleDocChange(e.target.value, index, "name");
                              }}
                              disabled={isReadOnly}
                              InputProps={{
                                sx: {
                                  backgroundColor: "#f5f5f5",
                                  "&.Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                  },
                                },
                              }}
                              inputProps={{
                                readOnly: true,
                              }}
                            ></TextField>
                          </Box>
                        </Grid>
                        <Grid item xs={2} lg={1.5} sx={styles.secondGrid}>
                          <Box sx={styles.btnGridAction}>
                            {!isReadOnly && index === 0 && (
                              <Box sx={styles.addIcons} onClick={handleAddDoc}>
                                +
                              </Box>
                            )}

                            {!isReadOnly && index !== 0 && (
                              <Box
                                sx={styles.deleteIcons}
                                onClick={() => handleDeleteDoc(index)}
                              >
                                <DeleteOutlineIcon />
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      </>
                    ))}
                  </Grid>

                  <Box></Box>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                ml="2%"
                mt="2%"
                mb="2%"
              >
                <Box
                  sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
                ></Box>
                <Typography sx={styles.textsize}>Social Media</Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sx={styles.card}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} lg={6}>
                      <Typography sx={styles.textside}>
                        {" "}
                        Paste Url Skype{" "}
                      </Typography>
                      <Box display="flex">
                        <img
                          src={Vector}
                          alt="Skype"
                          style={{ marginRight: "5%" }}
                        />
                        <CustomInput
                          name="urlSkype"
                          defaultValue={updateProfile?.urlSkype.value}
                          onChange={handleChange}
                          value={urlSkype?.value}
                          onFocus={handleFocus}
                          error={urlSkype.error}
                          readOnly={true}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <Typography sx={styles.textside}>
                        Paste Url LinkedIn
                      </Typography>
                      <Box display="flex">
                        <img
                          src={linkedin}
                          alt="linkedIn"
                          style={{ marginRight: "5%" }}
                        />
                        <CustomInput
                          name="urlLinkedin"
                          defaultValue={updateProfile?.urlLinkedin.value}
                          value={urlLinkedin?.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          error={urlLinkedin.error}
                          sx={{ borderRadius: "30px", ml: 2 }}
                          readOnly={true}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <Typography sx={styles.textside}>
                        Paste Url Instagram
                      </Typography>
                      <Box display="flex">
                        <img
                          src={insta}
                          alt="insta"
                          style={{ marginRight: "5%" }}
                        />
                        <CustomInput
                          name="urlInsta"
                          value={urlInsta?.value}
                          defaultValue={updateProfile?.urlInsta.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          error={urlInsta.error}
                          sx={{ borderRadius: "30px", ml: 2 }}
                          readOnly={true}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <Typography sx={styles.textside} ms={4}>
                        Paste Url Facebook
                      </Typography>
                      <Box display="flex">
                        <img src={fb} alt="fb" style={{ marginRight: "5%" }} />
                        <CustomInput
                          name="urlFb"
                          defaultValue={updateProfile?.urlFb.value}
                          value={urlFb?.value}
                          onChange={handleChange}
                          onFocus={handleFocus}
                          error={urlFb.error}
                          sx={{ borderRadius: "30px" }}
                          readOnly={true}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default ViewEmployeePage;
